import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import Swal from 'sweetalert2';
import gql from 'graphql-tag';
import moment from 'moment';
import Loader from '../../components/CustomLoader';
import client from '../../utils/apolloClient';
import { getUser } from '../../data-services/queries';
import { listEntriesByFcp, probeTable } from './ettcSubmissionApi';
import Waiting from '../../images/wait.png';
import Confirm from '../../images/confirm.png';

const styles = () => ({
    fab: {
        right: 0,
        bottom: 0,
        position: 'fixed',
        margin: '20px',
    },
});

class ListETTCSubmissions extends Component {
    state = {
        loading: true,
        userData: null,
        entries: [],
        tableOk: true,
    };

    async componentDidMount() {
        const { data } = await client.query({ query: gql(getUser) });
        const userData = data && data.user;
        this.setState({ userData });

        if (!userData || userData.role !== 'FCP' || !userData.sfid) {
            this.setState({ loading: false });
            return;
        }

        const probe = await probeTable();
        if (!probe.ok) {
            this.setState({ loading: false, tableOk: false });
            Swal.fire({
                icon: 'warning',
                title: 'ETTC table not ready',
                text:
                    'FCP_Submission__c is not available via Heroku Connect yet. Ask admin to sync the object, then retry.',
            });
            return;
        }

        try {
            const entries = await listEntriesByFcp(userData.sfid);
            this.setState({ entries, loading: false, tableOk: true });
        } catch (err) {
            this.setState({ loading: false, tableOk: false });
            Swal.fire({
                icon: 'error',
                title: 'Load failed',
                text: (err && err.message) || 'Could not load ETTC submissions.',
            });
        }
    }

    gotoBack = () => {
        this.props.history.push('/newHomeFCP');
    };

    createNew = () => {
        if (!this.state.tableOk) return;
        this.props.history.push({
            pathname: '/ettc-submission',
            search: '?new=1&back=/ettc-submissions',
        });
    };

    openEntry = (entry) => {
        const first = entry.submissions && entry.submissions[0];
        this.props.history.push({
            pathname: '/ettc-submission',
            search: first
                ? `?id=${first.id}&batch=${encodeURIComponent(entry.batchKey)}&back=/ettc-submissions`
                : `?batch=${encodeURIComponent(entry.batchKey)}&back=/ettc-submissions`,
        });
    };

    formatDate = (value) => {
        if (!value) return '-';
        return moment(value).isValid() ? moment(value).format('DD-MMM-YYYY') : value;
    };

    render() {
        const { classes } = this.props;
        const { loading, entries, tableOk, userData } = this.state;

        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.gotoBack}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit">
                            My ETTC Submissions
                        </Typography>
                    </Toolbar>
                </AppBar>

                {loading ? (
                    <Grid container alignItems="center" justify="center" style={{ marginTop: 24 }}>
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <Paper square>
                        {!entries.length ? (
                            <Typography style={{ padding: 16 }}>
                                No submissions yet. Tap + to add your first entry.
                            </Typography>
                        ) : (
                            entries.map((entry) => {
                                const isPending = entry.pending > 0;
                                const statusLabel = isPending ? 'Pending' : 'Approved';
                                return (
                                    <div key={entry.batchKey}>
                                        <List
                                            onClick={() => this.openEntry(entry)}
                                            style={{ cursor: 'pointer', padding: 12 }}
                                        >
                                            <Grid container spacing={8} alignItems="center">
                                                <Grid item xs={7}>
                                                    <Typography variant="body2">
                                                        {entry.submissionName || 'ETTC'}
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        {entry.total} submission
                                                        {entry.total === 1 ? '' : 's'} ·{' '}
                                                        {this.formatDate(entry.submission_date__c)} ·{' '}
                                                        {entry.evaluated_by_name || 'Evaluator TBD'}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography
                                                        align="right"
                                                        variant="body1"
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'flex-end',
                                                        }}
                                                    >
                                                        {statusLabel}
                                                        <img
                                                            src={isPending ? Waiting : Confirm}
                                                            alt={statusLabel}
                                                            style={{ width: 30, paddingLeft: 10 }}
                                                        />
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </List>
                                        <Divider />
                                    </div>
                                );
                            })
                        )}
                    </Paper>
                )}

                {userData && userData.role === 'FCP' && tableOk ? (
                    <Fab
                        color="primary"
                        aria-label="Add"
                        onClick={this.createNew}
                        className={classes.fab}
                    >
                        <AddIcon />
                    </Fab>
                ) : null}
            </div>
        );
    }
}

export default withStyles(styles)(ListETTCSubmissions);
